"use client";

import { Button } from "@yardzen/ui/components/button";
import { Spinner } from "@yardzen/ui/components/spinner";
import { useFormStatus } from "react-dom";

export function SkipButton() {
  const { pending } = useFormStatus();

  return (
    <Button
      className="w-full sm:w-fit"
      variant="outline"
      endIcon={pending ?? <Spinner className="size-4" />}
      type="submit"
      disabled={pending}
    >
      Skip this question
    </Button>
  );
}
